/*! @pentacode/ui v0.1.0 */
// src/elements/icon/active-icon.ts
function e(e, t) {
	return t ? `${e}:active` : e;
}
export { e as activeIcon };

//# sourceMappingURL=active-icon.js.map